import { SAVE_ACCESSIBILITY } from './actionTypes'
import { AccessibilityTypes } from './types'
import { AccessibilityModel } from '../../../types/accessibility/accessibilityModel'

export const saveAccessibility = (accessibilityData: AccessibilityModel): AccessibilityTypes => {
	return (
		{
			type: SAVE_ACCESSIBILITY,
			payload: accessibilityData
		}
	)
}
